module.exports = __webpack_public_path__ + "img/forte7.0f4f6ce2.jpeg";